import Chart from 'chart.js/auto';
import {AlgoBase} from "./AlgoBase";
import {Hydra1ChartJS} from "./Hydra1";

export class Hydra2ChartJS extends Hydra1ChartJS {

  constructor(target) {
    super(target, 2);
  }

  async init() {

    this.graphIndex = 2;
    this.algortihmData = await this.buildDataset("data/algorithms/Hydra1and2.csv");

    const ctx = this.$widget.find("canvas");

    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: this.algortihmData.labels,
        datasets: [{
          label: 'Differential Pressure Setpoint', // [dynamic value in loadDataset()],
          data: this.algortihmData.mainDatasets[0],
          borderColor: '#6400FF',
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          annotation: {
            annotations: {
              line1: {
                type: 'line',
                title: "Maximum reset", // [dynamic value in loadDataset()],
                yMin: 15,
                yMax: 15,
                borderColor: '#EB2B31',
                borderDash: [4, 4],
                drawTime: 'beforeDraw',
                z: 1,
              },
              line2: {
                type: 'line',
                title: "Minimum reset", // [dynamic value in loadDataset()],
                yMin: 10,
                yMax: 10,
                borderColor: '#000000',
                borderDash: [4, 4],
                drawTime: 'beforeDraw',
                z: 1,
              },
            },
          },
          title: {
            display: true,
            text: '-', // [dynamic value in loadDataset()],
          }
        },
        elements: {
          line: {
            tension: 0.3,
          }
        },
        scales: {
          x: this.setupXAxis(this.algortihmData.labels.length / 3),
          y: {
            min: 8,
            max: 16,
            ticks: {
              callback: function (value, index, ticks) {
                return value + ' psi'; // Append the unit
              }
            },
          }
        }
      }
    });

    this.loadDataset(0)

    this.initEvents();

    this.ready();
  }

  async buildDataset(filename) {
    const hydra1Dataset = await super.buildDatasetFromCSV(filename, 2);
    return {
      labels: hydra1Dataset.labels,
      mainDatasets: hydra1Dataset.allDatasets[1],
      allDatasets: hydra1Dataset.allDatasets
    };
  }

}
